import {Component, Input, OnInit} from '@angular/core';
import {PreguntaModel} from '../models/pregunta.model';
import {VisitaServices} from '../services/visita.services';

@Component({
  selector: 'respuesta-component',
  templateUrl: '../templates/visitas/respuesta.component.html',
  styleUrls: ['../styles/rvg.styles.scss']
})
export class RespuestaComponent implements OnInit {
  @Input()
  pregunta: PreguntaModel;

  @Input()
  visita: string;

  @Input()
  indice: string;

  alert: any = undefined;

  constructor(private vs: VisitaServices) {
  }

  ngOnInit(): void {
    this.pregunta.indice = this.indice;
  }

  actualizarRespuesta() {

    let sub = this.vs.obsSaveResult.subscribe(d => {
      if (d.pregunta == this.pregunta._id) {
        if (d.update == 1)
          this.mostrarAlerta();
      }
      sub.unsubscribe();
    });
    this.vs.saveResultado(this.visita, this.pregunta._id, this.pregunta.resultado);
  }

  subirFoto(files: FileList) {
    let fileToUpload = files.item(0);

    if (fileToUpload)
      this.vs.subirFoto(fileToUpload, this.visita, this.pregunta.resultado).subscribe(d => {
        console.log(d);
        if (d) {
          this.mostrarAlerta(d.message);
        }
      });
  }

  mostrarAlerta(mensaje?: string) {

    if (mensaje)
      this.alert = {
        type: 'success',
        msg: mensaje,
        timeout: 2000
      };
    else
      this.alert = {
        type: 'success',
        msg: 'Respuesta Almacenada',
        timeout: 1000
      };
  }

  closeAlert() {
    this.alert = undefined;
  }
}

